$(document).ready(function () {
  var $headerSlider = $('.header-main-sec');

  if ($headerSlider.length && !$headerSlider.hasClass('slick-initialized')) {
    $headerSlider.slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      dots: true,
      arrows: true,
      autoplay: false,
      autoplaySpeed: 2000,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  }

  var $collectionSlider = $('.slick_slier11');

  if ($collectionSlider.length && !$collectionSlider.hasClass('slick-initialized')) {
    $collectionSlider.slick({
      centerMode: true,
      centerPadding: '60px',
      slidesToShow: 8,
      slidesToScroll: 1,
      autoplay: true,
      pauseOnFocus: false,
      pauseOnHover: false,
      autoplaySpeed: 2000,
      dots: true,
      arrows: true,
      draggable: true,
      swipeToSlide: true,
      touchThreshold: 10,
      responsive: [
        {
          breakpoint: 1200,
          settings: { slidesToShow: 6 }
        },
        {
          breakpoint: 992,
          settings: { slidesToShow: 5 }
        },
        {
          breakpoint: 768,
          settings: { slidesToShow: 1 }
        },
        {
          breakpoint: 576,
          settings: { slidesToShow: 1 }
        },
        {
          breakpoint: 400,
          settings: { slidesToShow: 1 }
        }
      ]
    });
  }
});
